import React, { useRef, useState } from "react";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { withRouter  } from 'react-router-dom';
import 'moment/locale/ru';
import { styles } from "../../../containers/goods/styles";
import Loader from "../../utils/Loader";
import { parseNumToFixed } from "../../../utils/common";
import { useOnClickOutside } from "../../../hooks";
import swal from 'sweetalert';
import { UpdatePayment } from "../../../pages/accounting/invoice/UpdatePayment";
import request from "../../../action/utils/request";
import { urls } from "../../../constants/app";
import { fetchArticleCash } from "../../../action/handbook";
import { updateWithPayment } from "../../../action/cassa";

function ModalDetailData({ nextId, setDetailData, loading, detail, onClose }) {
    const ref = useRef();

    const initData = {
        id: nextId,
        name: null,
        sum: 0,
        payment: false,
    };

    const { type, isEdit, index, totalSum, ...item } = detail;

    const [data, setData] = useState(isEdit && !isEmpty(item) ? item : initData);

    const renderTitle = () => {
        if (type === 'totalPayrolls') {
            if (isEdit) return 'Редактирование начисления';
            return 'Добавление начисления';
        }
        if (isEdit) return 'Редактирование выплаты';
        return 'Добавление выплаты';
    }

    useOnClickOutside(ref, () => onClose(null, null));

    const onChangeInput = (field) => (e) => {
        const updated = {...data};
        updated[field] = e.target.value;
        setData(updated);
    }

    const onChangeNumberInput = (field) => (e) => {
        const updated = {...data};
        updated[field] = parseNumToFixed(e);
        setData(updated);
    }

    const onSubmit = () => {
        setDetailData(type, data, index);
        onClose(null, null);
    }

    return (
        <>
        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
          <div  className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
              <div ref={ref} className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{renderTitle()}</h5>
                  <button onClick={() => onClose(null, null)} type="button" className="close">
                  </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                      <label className="form-control-label">Название *</label>
                      <input disabled={loading} type="text" value={data.name} className="form-control" onChange={onChangeInput('name')} />
                    </div>
                    <div className="form-group">
                      <label className="form-control-label">Сумма *</label>
                      <input disabled={loading} type="number" value={data.sum} className="form-control" onChange={(e) => onChangeNumberInput('sum')(e.target.value)} />
                      {totalSum && <span style={{ cursor: 'pointer', color: 'blue' }} onClick={() => onChangeNumberInput('sum')(totalSum)}>{`Остаток: ${totalSum}`}</span>}
                    </div>
                </div>
    
                <div className="modal-footer">
                  <button disabled={loading} type="button" className="btn btn-secondary" onClick={() => onClose(null, null)}>Отмена</button>
                  <button
                    onClick={onSubmit}
                    disabled={loading || !data || !data.name || !data.sum}
                    className='btn btn-primary'>
                      Сохранить
                  </button>
                </div>
              </div>
            </div>
        </div>
        </>
    );
}

function EditWagesData({ data, edit, calculateTotal, onRefresh, setData }) {
    const loadingPoints = useSelector(state => state.loaders.filials);
    const loadingWages = useSelector(state => state.loaders.wages);
    const settings = useSelector(state => state.settings.init);
    const articles = useSelector(state => state.handbook.articlesCash);
    const loading = loadingPoints || loadingWages;
    const [ editDetail, setEditDetail ] = useState(null);
    const [ isModalOpen, setIsModalOpen ] = useState(false);

    const dispatch = useDispatch();

    if (loading) return(
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const setDetailData = (field, values, index) => {
        if (!field) return;
        if (!data || isEmpty(data)) return;
        if (index != null) {
            const updated = { ...data };
            updated[field][index] = values;
            updated.isChange = true;
            return setData(updated);
        }

        if (!isEmpty(values)) {
            const updated = { ...data };
            updated[field] = [...(updated[field] || []), values];
            updated.isChange = true;
            return setData(updated);    
        }
    }

    const onDeleteData = (field, index) => {
        if (!field) return;
        const updated = { ...data };
        if (isEmpty(updated)) return;
        const item = updated[field][index];
        if (!item) return;

        if (item.payment && item.payment !== 'none') return swal({
            title: "Удаление невозможно",
            text: 'Выплата оплачена',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });

        return swal({
            title: "Удаление данных",
            text: `Вы действительно хотите удалить ${field === 'totalPayrolls' ? 'начисление' : 'выплату'} ${item.name || ''} на сумму ${item.sum}`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                updated[field] = updated[field].filter((item, itemIndex) => itemIndex !== index);
                updated.isChange = true;
                setData(updated);
            }
        })
        
    }

    const setEdit = (item, type, index) => {
        if (!item && !type) return setEditDetail(null);
        if (index == null) {
            const detail = { type }
            let totalSum;
            if (type === 'totalPayments') totalSum = parseNumToFixed(calculateTotal('totalPayrolls', data) - calculateTotal('totalPayments', data));
            if (totalSum) detail.totalSum = totalSum;
            return setEditDetail(detail);
        }

        if (item.payment && item.payment !== 'none') return swal({
            title: "Изменение невозможно",
            text: 'Выплата оплачена',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });

        const detail = {
            ...item,
            type,
            isEdit: true,
            index,
        }
        return setEditDetail(detail);
    }

    const handleSubmitPayment = async (item, index, payment, workingShiftId, refund) => {
        if (!data || !data.id) return;
      
        const sendedData = JSON.parse(JSON.stringify(data));
      
        sendedData.totalPayments[index] = { ...item, payment: refund ? 'none' : payment };
        sendedData.isChange = true;
      
        const articlesCash = settings.articlesCash || {};
        const text = refund ? 'Возврат выплаты' : 'Оплата выплаты';
      
        const dataArticle = {
            typeTransaction: payment,
            sum: item.sum,
            name: text,
            notRefunded: true,
            typeMovementCash: refund ? 'income' : 'expenditure',
            wageId: data.id + '_' + item.id,
            movementPay: refund ? 'refund' : 'pay',
            comment: text + (item.name ? ': ' + item.name : '')
        };
      
        if (refund) dataArticle.refund = true;
      
        if (articlesCash.paymentWages) {
          const articleId = parseInt(articlesCash.paymentWages, 10);
          dataArticle.articleId = articleId;
      
          let articleName = null;
          if (articles && articles.length > 0) {
            const entity = articles.find((article) => article.id === articleId);
            if (entity && entity.name) articleName = entity.name;
          }
      
            if (!articleName) {
                const entity = await dispatch(fetchArticleCash(articleId));
                if (entity && entity.name) articleName = entity.name;
            }
      
            if (articleName) dataArticle.name = articleName;
        }
        // } else {
        //     return swal({
        //         title: 'Ошибка сохранения данных',
        //         text: 'Не найдена статья "Оплата выплаты"',
        //         icon: 'error',
        //         dangerMode: true,
        //         button: 'Ок'
        //     });
        // }
      
        try {
            const result = await dispatch(updateWithPayment({ workingShiftId: workingShiftId, article: dataArticle}, sendedData, data.id));
      
            if (result) {
                setIsModalOpen(false);
                onRefresh();
            }
        } catch (error) {
            const text = [];
            const errorData = error.data || {};
            if (errorData.statusCode) text.push(`Код ошибки: ${errorData.statusCode}`);
            if (errorData.message) text.push(errorData.message);
      
            return swal({
                title: 'Ошибка сохранения данных',
                text: text.join('. '),
                icon: 'error',
                dangerMode: true,
                button: 'Ок'
            });
        }
    };

    const handlePaymentMethod = (item, index) => async (method, refund) => {
        const getWorkingShift = async () => {
            const params = {
                'closed_at_null': true,
                'point.id': data.pointId
            };
            const workingShift = await request({ method: 'get', url: urls.workingShift, params });
            return workingShift;
        }

        const workingShift = await getWorkingShift();
        if (workingShift.length <= 0) return swal({
            title: "Смена закрыта",
            text: "Смена закрыта, оплата невозможна. Откройте смену и повторите попытку.",
            icon: "warning",
            dangerMode: true,
            button: "Ок",
        });

        handleSubmitPayment(item, index, method, workingShift[0].id, refund);
    };

    const getNextId = (field) => {
        if (isEmpty(data) || isEmpty(data[field])) return 1;
        if (data[field].length === 0) return 1;
        return data[field][data[field].length - 1].id + 1;
    }

    const renderBody = () => {        
        return (
            <>
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <h3 style={{ color: '#000', padding: 10 }}>{edit.name ? edit.name : edit.value}</h3>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '10px' }}>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <h4 style={{ color: '#000', borderBottom: '1px solid rgb(235, 237, 242)' }}> Начисления <button onClick={() => setEdit(null, 'totalPayrolls')} className="btn btn-icon btn-success" style={{ scale: '0.7' }}> <i className="flaticon2-plus"/> </button> </h4>
                        <table className='kt-datatable__table'>
                            <thead className='kt-datatable__head'>
                                <tr className='kt-datatable__row'>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}><span>Наименование</span></th>
                                    <th className='kt-datatable__cell'></th>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}><span>Сумма</span></th>
                                </tr>
                            </thead>
                            <tbody className='kt-datatable__body'>
                                {data && !isEmpty(data.totalPayrolls) &&
                                    data.totalPayrolls.map((item, index) => (
                                        <tr className="kt-datatable__row">
                                            <td style={{ width: 'auto' }}  className="kt-datatable__cell">
                                                <div style={{ display: 'flex', gap: '10px'}}>
                                                    <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => setEdit(item, 'totalPayrolls', index)}>
                                                        {item.name}
                                                    </span>
                                                    <button onClick={() => onDeleteData('totalPayrolls', index)} className="button_order_table">
                                                        <i className="kt-nav__link-icon flaticon2-trash order_table"/>
                                                    </button>
                                                </div>
                                            </td>
                                            <td style={{ width: '30%' }} className="kt-datatable__cell"><span></span></td>
                                            <td style={{ color: '#000', width: '30%' }} className="kt-datatable__cell"><span>{item.sum}</span></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <h4 style={{ color: '#000', borderBottom: '1px solid rgb(235, 237, 242)' }}> Выплаты <button onClick={() => setEdit(null, 'totalPayments')} className="btn btn-icon btn-success" style={{ scale: '0.7' }}> <i className="flaticon2-plus"/> </button> </h4>
                        <table className='kt-datatable__table'>
                            <thead className='kt-datatable__head'>
                                <tr className='kt-datatable__row'>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}><span>Наименование</span></th>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}>Оплата</th>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}><span>Сумма</span></th>
                                </tr>
                            </thead>
                            <tbody className='kt-datatable__body'>
                                {data && !isEmpty(data.totalPayments) &&
                                    data.totalPayments.map((item, index) => (
                                        <tr className="kt-datatable__row">
                                            <td style={{ width: 'auto' }} className="kt-datatable__cell">
                                                <div style={{ display: 'flex', gap: '10px'}}>
                                                    <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => setEdit(item, 'totalPayments', index)}>
                                                        {item.name}
                                                    </span>
                                                    <button onClick={() => onDeleteData('totalPayments', index)} className="button_order_table">
                                                        <i className="kt-nav__link-icon flaticon2-trash order_table"/>
                                                    </button>
                                                </div>
                                            </td>
                                            <td style={{ width: '30%', display: 'flex', alignItems: 'center' }} className="kt-datatable__cell">
                                            {item.payment && item.payment !== 'none' ? (
                                                <>
                                                    <span style={{ marginRight: '8px' }}>Оплачено {item.payment === 'cash' ? 'Наличные' : 'Расчетный счет'}</span>
                                                    <span 
                                                        className="kt-switch kt-switch--sm kt-switch--icon"
                                                        onClick={() => setIsModalOpen(item.id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={true}
                                                            readOnly
                                                        />
                                                        <span className="new_order_switch"></span>
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <span style={{ marginRight: '8px' }}>Оплатить из кассы</span>
                                                    <span
                                                        className="kt-switch kt-switch--sm kt-switch--icon"
                                                        onClick={() => setIsModalOpen(item.id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={false}
                                                            readOnly
                                                        />
                                                        <span className="new_order_switch"></span>
                                                    </span>
                                                </>
                                            )}
                                            <UpdatePayment
                                                isOpen={isModalOpen === item.id}
                                                onClose={() => setIsModalOpen(false)}
                                                totalSum={parseNumToFixed(item.sum) || 0}
                                                onPaymentMethod={handlePaymentMethod(item, index)}
                                                payment={item.payment}
                                            />
                                            </td>
                                            <td style={{ color: '#000', width: '30%' }} className="kt-datatable__cell"><span>{item.sum}</span></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ display: 'flex', padding: '10px' }}>
                    <table className='kt-datatable__table' style={{ width: '50%' }}>
                        <tbody className='kt-datatable__body'>
                            <tr className="kt-datatable__row">
                                <td style={{ color: '#000', cursor: 'pointer', width: 'auto' }} className="kt-datatable__cell"><span>Итого</span></td>
                                <td style={{ width: '30%' }} className="kt-datatable__cell"></td>
                                <td style={{ color: '#000', width: '30%' }} className="kt-datatable__cell"><span>{calculateTotal('totalPayrolls', data)}</span></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className='kt-datatable__table' style={{ width: '50%' }}>
                        <tbody className='kt-datatable__body'>
                            <tr className="kt-datatable__row">  
                                <td style={{ color: '#000', width: 'auto' }} className="kt-datatable__cell"><span>Итого</span></td>
                                <td style={{ width: '30%' }} className="kt-datatable__cell"></td>
                                <td style={{ color: '#000', width: '30%' }} className="kt-datatable__cell"><span>{calculateTotal('totalPayments', data)}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {!isEmpty(editDetail) && <ModalDetailData nextId={getNextId(editDetail.type)} setDetailData={setDetailData} onClose={setEdit} loading={loading} detail={editDetail}/>}
            </>
        );
    }

    return renderBody();
}

export default withRouter(EditWagesData);